import React, { Component } from 'react';
import './btn.css';
import GeckoIcon from '../icon/icon';
import { APP_CONST } from '../../constants';
import { Utils } from '../../services';

class GeckoBtn extends Component {

    state = {
        disabled: false
    };

    renderId() {
        if (!this.props.id) return undefined;
        return `gecko-btn-${this.props.id}`;
    }

    preparePreset(key){
        if (this.props.preset && APP_CONST.BTN_PRESETS[this.props.preset] && APP_CONST.BTN_PRESETS[this.props.preset][key]){
            return APP_CONST.BTN_PRESETS[this.props.preset][key];
        }
        return null;
    }

    // Prepare class name
    prepareClass() {
        let type = this.props.type || this.preparePreset('type') || APP_CONST.BTN_TYPE_DEFAULT;
        return APP_CONST.BTN_CLASSES[type];        
    }

    prepareIcon() {
        return this.props.icon || this.preparePreset('icon');
    }

    // Render button name
    renderName() {
        return this.props.name || this.preparePreset('name') || null;
    }

    renderAriaLabel() {
        return this.props.ariaLabel || this.preparePreset('ariaLabel') || null;
    }

    // Render button class
    renderClass() {
        return Utils.classNames({
            [Utils.prepareNameClass('gecko-btn', this.renderName())]: this.renderName(),
            'gecko-btn gecko-ui-material btn': true,
            [this.prepareClass()]: true,
            'icon-only': !this.renderName() && this.prepareIcon(),
            [`btn-${this.props.size}`]: this.props.size,
            [this.props.className]: this.props.className
        });
    }

    renderIcon() {
        if (this.props.icon || this.preparePreset('icon')) {
            return <GeckoIcon icon={this.prepareIcon()} />
        }
        return null;
    }

    renderSrOnly() {
        if (!this.renderName() && this.renderAriaLabel()) {
            return (<span className="sr-only">{this.renderAriaLabel()}</span>);
        }
        return null;
    }

    isDisabled() {
        return this.state.disabled || (this.props.disabledWhen ? this.props.disabledWhen() : false);
    }

    isHidden()
    {
        if (this.props.hideWhen && this.props.hideWhen()) {
            return true;
        }

        return false;
    }

    handler() {
        let handler = this.props.handler();

        // If promise is returned disable button
        if (handler && handler instanceof Promise) {
            // Disable button
            this.setState({disabled: true});
            // Undisable button after promise has resolved or rejected
            return handler.then(() => {
                return this.setState({disabled: false});
            }).catch(() => {
                return this.setState({disabled: false});
            });
        }
    }

    render() {
        if (this.isHidden()) {
            return null;
        }


		return (
            <button
                id={this.renderId()}
                type="button"
                role="button"
                aria-label={this.props.ariaLabel || this.renderName()}
                style={this.props.style}
                className={this.renderClass()}
                onClick={this.handler.bind(this)}
                disabled={this.isDisabled()}>

                    {this.renderIcon()}

                    {this.renderName()}

                    {this.renderSrOnly()}

            </button>
        );
    }
}

GeckoBtn.defaultProps = {
    handler: () => {},
    style: {},
};

//GeckoBtn.propTypes = GeckoBtnModel;

export default GeckoBtn;